import { useTranslation } from 'react-i18next'
import ChecklistPanel from './ChecklistPanel'
import useDoorToDoorPartnerChecklist from './useDoorToDoorPartnerChecklist'
import usePulseScope from '@/shared/components/PulseScope/usePulseScope'
import { ChecklistDisclaimer, ChecklistList } from './styled-components'

const DoorToDoorPartnerChecklist = () => {
  const { t } = useTranslation()
  const isPulse = usePulseScope()
  const {
    isDoorToDoorPartner,
    introductionChecklist,
    identityChecklist,
    presentationChecklist,
    visitPurposeChecklist,
    recapChecklist,
    checkedTitles,
    expanded,
    setCheckedTitle,
    toggleExpanded
  } = useDoorToDoorPartnerChecklist()

  if (!isDoorToDoorPartner) return null

  return (
    <ChecklistList $pulse={isPulse}>
      <ChecklistPanel
        idKey='introduction'
        data={introductionChecklist}
        checkedTitles={checkedTitles}
        toggleExpanded={toggleExpanded}
        setCheckedTitle={setCheckedTitle}
        expanded={expanded}
      />
      <ChecklistPanel
        idKey='identity'
        data={identityChecklist}
        checkedTitles={checkedTitles}
        toggleExpanded={toggleExpanded}
        setCheckedTitle={setCheckedTitle}
        expanded={expanded}
      />
      <ChecklistPanel
        idKey='presentation'
        data={presentationChecklist}
        checkedTitles={checkedTitles}
        toggleExpanded={toggleExpanded}
        setCheckedTitle={setCheckedTitle}
        expanded={expanded}
      />
      <ChecklistPanel
        idKey='visitPurpose'
        data={visitPurposeChecklist}
        checkedTitles={checkedTitles}
        toggleExpanded={toggleExpanded}
        setCheckedTitle={setCheckedTitle}
        expanded={expanded}
      />
      <ChecklistPanel
        idKey='recap'
        data={recapChecklist}
        checkedTitles={checkedTitles}
        toggleExpanded={toggleExpanded}
        setCheckedTitle={setCheckedTitle}
        expanded={expanded}
      />
      <ChecklistDisclaimer $pulse={isPulse}>
        {t('subscriptionForm:door_to_door_partner_checklist.disclaimer')}
      </ChecklistDisclaimer>
    </ChecklistList>
  )
}

export default DoorToDoorPartnerChecklist
